import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
});

const authHeaders = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const publicApi = {
  getContent: async () => (await client.get("/public/content")).data,
  searchExperts: async (params) => (await client.get("/public/experts", { params })).data,
  uploadReference: async (formData) => (
    await client.post("/public/upload-reference", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
  ).data,
  submitApplication: async (payload) => (await client.post("/public/applications", payload)).data,
  submitComplaint: async (payload) => (await client.post("/public/complaints", payload)).data,
};

export const authApi = {
  login: async (payload) => (await client.post("/auth/login", payload)).data,
  me: async (token) => (await client.get("/auth/me", authHeaders(token))).data,
  requestPasswordReset: async (payload) => (await client.post("/auth/password-reset/request", payload)).data,
  confirmPasswordReset: async (payload) => (await client.post("/auth/password-reset/confirm", payload)).data,
};

export const memberApi = {
  getPortal: async (token) => (await client.get("/member/portal", authHeaders(token))).data,
  createTicket: async (token, payload) => (await client.post("/member/tickets", payload, authHeaders(token))).data,
  initiatePayment: async (token, payload) => (
    await client.post("/member/payments/initiate", payload, authHeaders(token))
  ).data,
  updateProfile: async (token, payload) => (await client.put("/member/profile", payload, authHeaders(token))).data,
  updatePassword: async (token, payload) => (await client.put("/member/password", payload, authHeaders(token))).data,
};

export const adminApi = {
  getSnapshot: async (token) => (await client.get("/admin/snapshot", authHeaders(token))).data,
  reviewApplication: async (token, applicationId, payload) => (
    await client.post(`/admin/applications/${applicationId}/review`, payload, authHeaders(token))
  ).data,
  updateTicketStatus: async (token, ticketId, payload) => (
    await client.post(`/admin/tickets/${ticketId}/status`, payload, authHeaders(token))
  ).data,
  updatePaymentStatus: async (token, paymentId, payload) => (
    await client.post(`/admin/payments/${paymentId}/status`, payload, authHeaders(token))
  ).data,
  createMember: async (token, payload) => (await client.post("/admin/members/create", payload, authHeaders(token))).data,
  updateMember: async (token, memberId, payload) => (await client.put(`/admin/members/${memberId}`, payload, authHeaders(token))).data,
  triggerMemberPasswordReset: async (token, memberId) => (
    await client.post(`/admin/members/${memberId}/password-reset`, {}, authHeaders(token))
  ).data,
  updateLegal: async (token, slug, payload) => (
    await client.put(`/admin/legal/${slug}`, payload, authHeaders(token))
  ).data,
  updateSettings: async (token, payload) => (
    await client.put("/admin/settings", payload, authHeaders(token))
  ).data,
  updateInternalGuide: async (token, payload) => (
    await client.put("/admin/internal-guide", payload, authHeaders(token))
  ).data,
  updateMailboxAnnotation: async (token, mailId, payload) => (
    await client.put(`/admin/mailbox/${mailId}/annotation`, payload, authHeaders(token))
  ).data,
  refreshNews: async (token) => (await client.post("/admin/ai-news/refresh", {}, authHeaders(token))).data,
  createSeminar: async (token, payload) => (
    await client.post("/admin/seminars", payload, authHeaders(token))
  ).data,
  downloadFile: async (token, fileId) => (
    await client.get(`/files/${fileId}`, { ...authHeaders(token), responseType: "blob" })
  ).data,
  downloadAdminDocument: async (token, path) => (
    await client.get(path, { ...authHeaders(token), responseType: "blob" })
  ).data,
};
